export default __webpack_public_path__ + "1092939d9008ca4813be18d8d3589d14.png";